import { cleanPhoneNumber } from '../../../utils/phoneUtils';

// Local normalize for search (Preserves order, unlike utils/normalize which sorts)
export const normalizeForSearch = (str) => {
    if (!str && str !== 0) return "";
    let s = String(str).toLowerCase();
    s = s.replace(/а/g, 'a').replace(/с/g, 'c').replace(/е/g, 'e').replace(/о/g, 'o').replace(/р/g, 'p');
    const numericOnly = s.replace(/\D/g, '');
    // Only a phone-like text (digits and separators, no letters) is cleaned as a phone: a contract
    // number such as "I2609000D1443839" lost its letters here, so a mistyped number could match
    // another contract with the same digits (26 Sep 2026).
    if (!/[a-z\u0600-\u06FF]/.test(s) && numericOnly.length >= 7 && numericOnly.length <= 15) {
        // Looks like a phone number? Try cleaning it to local format
        try {
            const cleaned = cleanPhoneNumber(numericOnly);
            if (cleaned) return cleaned;
        } catch { /* ignore */ }
    }
    // one spelling for alef / ta marbuta / ya, as the new store's search keys (\u0623\u062D\u0645\u062F = \u0627\u062D\u0645\u062F, \u0641\u0627\u0637\u0645\u0629 = \u0641\u0627\u0637\u0645\u0647)
    return s.toLowerCase().trim().replace(/[\u0623\u0625\u0622\u0671]/g, '\u0627').replace(/\u0629/g, '\u0647').replace(/\u0649/g, '\u064A')
        .replace(/[^a-z0-9\u0600-\u06FF]/g, '');
};
